import { render, staticRenderFns } from "./curingSubcontractAddOrUpdate.vue?vue&type=template&id=2c1170df&scoped=true&"
import script from "./curingSubcontractAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./curingSubcontractAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1170df",
  null
  
)

export default component.exports